videojs.addLanguage('sk', {
  "Audio Player": "Zvukový prehrávač",
  "Video Player": "Video prehrávač",
  "Play": "Prehrať",
  "Pause": "Pozastaviť",
  "Replay": "Prehrať znova",
  "Current Time": "Aktuálny čas",
  "Duration": "Čas trvania",
  "Remaining Time": "Zostávajúci čas",
  "Stream Type": "Typ stopy",
  "LIVE": "NAŽIVO",
  "Loaded": "Načítané",
  "Progress": "Priebeh",
  "Progress Bar": "Ukazovateľ priebehu",
  "progress bar timing: currentTime={1} duration={2}": "časovanie ukazovateľa priebehu: currentTime={1} duration={2}",
  "Fullscreen": "Režim celej obrazovky",
  "Non-Fullscreen": "Režim normálnej obrazovky",
  "Mute": "Stlmiť",
  "Unmute": "Zrušiť stlmenie",
  "Playback Rate": "Rýchlosť prehrávania",
  "Subtitles": "Titulky",
  "subtitles off": "titulky vypnuté",
  "Captions": "Popisky",
  "captions off": "popisky vypnuté",
  "Chapters": "Kapitoly",
  "Descriptions": "Opisy",
  "descriptions off": "opisy vypnuté",
  "Audio Track": "Zvuková stopa",
  "Volume Level": "Úroveň hlasitosti",
  "You aborted the media playback": "Prerušili ste prehrávanie",
  "A network error caused the media download to fail part-way.": "Sťahovanie súboru bolo zrušené pre chybu na sieti.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Súbor sa nepodarilo načítať pre chybu servera, sieťového pripojenia, alebo je formát súboru nepodporovaný.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Prehrávanie súboru bolo prerušené pre poškodené dáta, alebo súbor používa vlastnosti, ktoré váš prehliadač nepodporuje.",
  "No compatible source was found for this media.": "Nebol nájdený žiaden kompatibilný zdroj pre tento súbor.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Súbor je zašifrovaný a nie je k dispozícii kľúč na rozšifrovanie.",
  "Play Video": "Prehrať video",
  "Close": "Zatvoriť",
  "Close Modal Dialog": "Zatvoriť modálne okno",
  "Modal Window": "Modálne okno",
  "This is a modal window": "Toto je modálne okno",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Toto modálne okno je možné zatvoriť stlačením klávesy Escape, alebo aktivovaním tlačidla na zatvorenie.",
  ", opens captions settings dialog": ", otvorí okno nastavení popiskov",
  ", opens subtitles settings dialog": ", otvorí okno nastavení titulkov",
  ", opens descriptions settings dialog": ", otvorí okno nastavení opisov",
  ", selected": ", označené",
  "captions settings": "nastavenia popiskov",
  "subtitles settings": "nastavenia titulkov",
  "descriptions settings": "nastavenia opisov",
  "Text": "Text",
  "White": "Biela",
  "Black": "Čierna",
  "Red": "Červená",
  "Green": "Zelená",
  "Blue": "Modrá",
  "Yellow": "Žltá",
  "Magenta": "Ružová",
  "Cyan": "Tyrkysová",
  "Background": "Pozadie",
  "Window": "Okno",
  "Transparent": "Priesvitné",
  "Semi-Transparent": "Polopriesvitné",
  "Opaque": "Plné",
  "Font Size": "Veľkosť písma",
  "Text Edge Style": "Typ okrajov písma",
  "None": "Žiadne",
  "Raised": "Zvýšené",
  "Depressed": "Znížené",
  "Uniform": "Pravidelné",
  "Dropshadow": "S tieňom",
  "Font Family": "Typ písma",
  "Proportional Sans-Serif": "Proporčné bezpätkové",
  "Monospace Sans-Serif": "Pravidelné, bezpätkové",
  "Proportional Serif": "Proporčné pätkové",
  "Monospace Serif": "Pravidelné pätkové",
  "Casual": "Bežné",
  "Script": "Písané",
  "Small Caps": "Malé kapitálky",
  "Reset": "Resetovať",
  "restore all settings to the default values": "všetky nastavenia na základné hodnoty",
  "Done": "Hotovo",
  "Caption Settings Dialog": "Okno nastavení popiskov",
  "Beginning of dialog window. Escape will cancel and close the window.": "Začiatok okna. Klávesa Escape zruší a zavrie okno.",
  "End of dialog window.": "Koniec okna.",
  "{1} is loading.": "{1} sa načíta."
});